module.exports = __webpack_public_path__ + "img/adviser-enrolment-header.c902b3c5.png";